import { useLocation, useNavigate, useParams } from 'react-router';
import AppNavLink from '@/components/Router/AppNavLink';
import { useProject, useProjectTeamMembers } from '../../../../../../hooks/ReactQueryHooks/useProjectQuery';
import { capitalize } from '../../../../../../utils';

const projectPhase: string[] = ['acquisition', 'finance', 'procurement', 'development', 'design', 'construction'];

interface IProjectNavProps {
  hasPhaseAccess: any;
}
const ProjectNav = ({ hasPhaseAccess }: IProjectNavProps) => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location);

  const fetchProject = useProject({ projectId: parseInt(projectId!, 10) });
  const project = fetchProject?.data?.data;

  const fetchProjectTeam = useProjectTeamMembers({
    projectId: parseInt(projectId!, 10),
  });
  const projectTeam = fetchProjectTeam?.data?.data;

  const projectSnacks: {
    id: number;
    message: string;
    messageType: string;
    messageActionLabel?: string;
    action: 'internal-teams' | 'external-teams' | 'project-goals' | 'project-vendors';
    onMessageAction?: () => void;
    onMessageClose?: () => void;
  }[] = [];

  if (project?.goals === null) {
    projectSnacks.push({
      id: 1,
      message: 'Project Minority and Social goals is empty. Would you like to add it ?',
      messageType: 'WARNING',
      action: 'project-goals',
      messageActionLabel: 'Add Project Social and Minority Goals',
    });
  }

  if (projectTeam && projectTeam?.internal?.length === 1) {
    projectSnacks.push({
      id: 2,
      message: 'Project Internal members are not selected yet. Would you like to select it ?',
      messageType: 'WARNING',
      action: 'internal-teams',
      messageActionLabel: 'Add Project Internal Members',
    });
  }

  if (projectTeam && projectTeam?.external?.length === 0) {
    projectSnacks.push({
      id: 3,
      message: 'Project vendors is not selected yet. Would you like to select it ?',
      messageType: 'WARNING',
      action: 'external-teams',
      messageActionLabel: 'Add Project Vendors',
    });
  }

  return (
    <>
      <div className='xl:hidden'>
        <label htmlFor='selected-tab' className='sr-only'>
          Select a tab
        </label>
        <select
          id='selected-tab'
          name='selected-tab'
          className='mt-1 block w-full pl-3 pr-10 py-4 border-neutralColor-light focus:outline-hidden rounded-md capitalize bg-white text-primaryColor-normal font-medium'
          onChange={(e) => navigate(e.target.value)}
        >
          <option value='dashboard'>Dashboard</option>
          {projectPhase.map((tab) => (
            <option key={tab} value={tab}>
              {capitalize(tab)}
            </option>
          ))}
        </select>
      </div>
      <div className='hidden xl:block'>
        <nav className='flex justify-between items-center w-full rounded-md shadow-md'>
          <AppNavLink
            to={`../${projectId}/dashboard`}
            baseClassName='whitespace-nowrap text-center py-4 border-b-4 font-bold text-md bg-white w-full'
            activeClassName='border-primaryColor-light text-primaryColor-normal'
            inactiveClassName='border-transparent hover:border-primaryColor-light hover:text-primaryColor-normal'
          >
            Dashboard
          </AppNavLink>

          {projectPhase.map((tab) => {
            if (hasPhaseAccess[tab as keyof typeof hasPhaseAccess]) {
              return (
                <AppNavLink
                  key={tab}
                  to={`../${projectId}/${tab}`}
                  baseClassName='whitespace-nowrap text-center py-4 border-b-4 font-bold text-md bg-white w-full capitalize'
                  activeClassName='border-primaryColor-light text-primaryColor-normal'
                  inactiveClassName='border-transparent hover:border-primaryColor-light hover:text-primaryColor-normal'
                >
                  {tab}
                </AppNavLink>
              );
            }
            return null;
          })}
        </nav>
        {/* {projectSnacks.map((snack) => (
                  <ProjectSnackBar
                    key={snack.id}
                    message={snack.message}
                    messageType={snack.messageType}
                    messageActionLabel={snack.messageActionLabel}
                    onMessageAction={() => {
                      const addInternalMemberButton = document.getElementById(
                        snack.action
                      );
                      addInternalMemberButton?.scrollIntoView({
                        behavior: "smooth",
                      });
                    }}
                  />
                ))} */}
      </div>
    </>
  );
};

export default ProjectNav;
